// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  CenteredContainerDisplay,
  TriggerableActionItem as ActionItem
} from '../'


export const Actions = ({
  userMayUpdate,
  bankaccountIsUpdateable,
  bankaccountNotUpdateableReason,
  onEditClick,
  onCancelClick,
  onBankChangeClick
}) => (
  <CenteredContainerDisplay
    content={
      <div className='slds-size_3-of-4 slds-m-left_x-large'>
        <div className='u-font-size-larger slds-m-bottom_medium'>
          <b>Actions</b>
        </div>
        <ActionItem
          name='Edit withdrawal'
          triggerLabel='edit'
          triggerOnClick={onEditClick}
          disabled={!userMayUpdate}
          className='slds-m-bottom_small'
        />
        <ActionItem
          name='Cancel withdrawal'
          triggerLabel='cancel'
          triggerOnClick={onCancelClick}
          disabled={!userMayUpdate}
          className='slds-m-bottom_small'
        />
        <ActionItem
          name='Change bank account'
          triggerLabel='change'
          triggerOnClick={onBankChangeClick}
          disabled={!bankaccountIsUpdateable}
          disabledReason={bankaccountNotUpdateableReason}
          className='slds-m-bottom_small'
        />
      </div>
    }
    yAdjustPercentage={-35}
    useFullWidth={true}
    className='slds-size_1-of-2'
  />
)

Actions.propTypes = {
  userMayUpdate: PropTypes.bool.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onBankChangeClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-detail/Actions.js